
export const PublicSellerWarrantyQuery = new TypedDocumentString(`
    query PublicSellerWarrantyQuery($sellerId: ObjectId!) {
  publicSellerWarranty(sellerId: $sellerId) {
    ...ProductWarranty
    __typename
  }
}
    fragment Duration on Duration {
  unit
  value
  __typename
}
fragment ProductWarranty on ProductWarranty {
  duration {
    ...Duration
    __typename
  }
  title {
    value
    __typename
  }
  document {
    _id
    __typename
  }
  __typename
}`, {"hash":"ef34bb22b63bb458b29a06ec1f067487bb08e8aa56cd87a216fb5f77e23f9014"});